import { Component, OnDestroy, OnInit } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable, of, Subscription } from "rxjs";
import { filterNullOrUndefined } from "src/app/@operators/filter-null-or-undefined";
import { CityDto, SiteDto } from "src/app/api/models";
import { AppState, getState } from "src/app/state/app.state";
import { resetCity } from "../../city/state/city.actions";
import { setTitle } from "../../title/state/title.actions";
import { resetCurrentCity, setSelectedSite } from "../../transaction-info/state/transaction-info.actions";
import { loadSiteByCity, resetSite } from "../state/site.actions";
import { getSiteListByCity } from "../state/site.selectors";

@Component({
    selector: "app-site",
    templateUrl: "./site.component.html",
    styleUrls: ["./site.component.scss"],
    standalone: false
})
export class SiteComponent implements OnInit,OnDestroy {
	public sites$: Observable<SiteDto[]> = this.store.pipe(select(getSiteListByCity)).pipe(filterNullOrUndefined());
	public properyToDisplay = "hospitalName";
	private city: CityDto;
	private subs: Subscription[] = [];

	constructor(private store: Store<AppState>) {
		this.subs.push(getState(this.store).subscribe(state =>{
			this.properyToDisplay = "hospitalName" + state.transactionInfo.selectedLanguage.languageCode;
			this.city = state.transactionInfo.selectedCity;
		}));
	}

	ngOnInit(): void {
		this.store.dispatch(
			setTitle({
				data: "TITLE_SELECT_HOSPITAL",
				data2: "TITLE_SELECT_HOSPITAL_INFO",
			})
		);
		this.store.dispatch(loadSiteByCity({ cityId: this.city.cityId }));

		this.subs.push(
			this.sites$.subscribe((sities) => {
				if (sities.length === 1) {
					this.store.dispatch(setSelectedSite({ data: sities[0] }));
				}
			})
		);
	}

	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}

	onClickRetour(): void {
		this.store.dispatch(resetSite());
		this.store.dispatch(resetCity());
		this.store.dispatch(resetCurrentCity());
	}

	public onClickHospital(site: SiteDto): void {
		this.store.dispatch(setSelectedSite({ data: site }));
	}
}
